import { BannerTypes, PredefinedBanner } from 'components/banner/types'

export const PredefinedBanners: Record<BannerTypes | string, PredefinedBanner> = {
  [BannerTypes.BRUSSELS_BEER_PROJECT]: {
    type: 'attention',
    titleNsAndKey: 'brusselsBeerProject:banner.title',
    descriptionNsAndKey: 'brusselsBeerProject:banner.small'
  },

  [BannerTypes.VIA_VIA]: {
    type: 'attention',
    titleNsAndKey: 'home:viralloopsnotification'
  },

  [BannerTypes.SIMULATION_DOWN]: {
    type: 'attention',
    titleNsAndKey: 'common:simulationDown.title',
    descriptionNsAndKey: 'common:simulationDown.apologies'
  }
}
